import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { c_dtable_site_default_settings_for_partition_component } from './c_dtable_site_default_settings_for_partition.component';
import { SharedModule } from '../../../../../app/directives/shared.module'
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MatSlideToggleModule
  ],
  declarations: [c_dtable_site_default_settings_for_partition_component],
  exports: [c_dtable_site_default_settings_for_partition_component],
})
export class c_dtable_site_default_settings_for_partition_module { }
